import type { CalendarEvent } from "./schedule-events";
import { StreamClock } from "./StreamClock";

export function DayDial({ day, events }: { day: string; events: CalendarEvent[] }) {
  return (
    <div className="min-w-0 rounded border border-neutral-200 bg-neutral-50 p-1.5 text-center">
      <div className="text-[11px] font-bold">{day}</div>
      <StreamClock events={events} />
    </div>
  );
}
